// src/utils/tournamentUtils.js
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { playSound } from '../utils/soundPlayer';

async function waitForAuth() {
  const auth = getAuth();
  if (auth.currentUser) return;
  await new Promise((resolve) => {
    const unsub = onAuthStateChanged(auth, () => {
      unsub();
      resolve();
    });
  });
}

export const handleJoinTournament = async (tournament, onComplete, onError) => {
  try {
    console.log('🔧 TournamentUtils: Starting tournament join for:', tournament.title);
    
    await waitForAuth();
    const auth = getAuth();
    const user = auth.currentUser;
    
    console.log('🔧 TournamentUtils: Auth state:', { user: !!user, uid: user?.uid });
    
    if (!user) {
      throw new Error('Please log in again to join the tournament.');
    }
    
    // Force fresh token to avoid 401 errors
    const token = await user.getIdToken(true);
    console.log('🔧 TournamentUtils: Token obtained:', !!token);

    if (!tournament?.id) {
      throw new Error('Invalid tournament data.');
    }

    console.log('🔧 TournamentUtils: Making API call to joinTournament function...');
    
    // Call the joinTournament function as HTTP request
    const response = await fetch(`https://us-central1-yme-dp-manager.cloudfunctions.net/joinTournament`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        tournamentId: tournament.id,
        tournamentData: tournament
      })
    });

    console.log('🔧 TournamentUtils: API response status:', response.status);
    const res = await response.json();
    console.log('🔧 TournamentUtils: API response data:', res);
    
    if (!response.ok) {
      throw new Error(res.error || 'Failed to join tournament');
    }

    if (!res?.success) {
      throw new Error(res?.error || 'Failed to join tournament');
    }

    console.log('🔧 TournamentUtils: Tournament join successful!');
    playSound('purchase'); // Use purchase sound for successful tournament join
    if (typeof onComplete === 'function') onComplete(res);
    
    return res;
  } catch (error) {
    console.error('❌ TournamentUtils: Tournament join error:', error?.message || error);
    if (typeof onError === 'function') {
      onError(error);
    } else {
      throw error;
    }
  }
};
